import { render } from "./bulk_create.vue?vue&type=template&id=23a26d50&scoped=true"
import script from "./bulk_create.vue?vue&type=script&lang=js"
export * from "./bulk_create.vue?vue&type=script&lang=js"

import "./bulk_create.vue?vue&type=style&index=0&id=23a26d50&scoped=true&lang=css"

import exportComponent from "F:\\code\\my_business\\giaiphapmmo_business_2023\\front_end\\company_for_tax\\admin_site\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23a26d50"]])

export default __exports__